import {Component, input, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertComponent} from "../../../../common/alert/alert.component";
import {AlertService} from "../../../../common/alert/alert.service";
import {PinholeUserService} from "../../services/pinhole.user.service";
import {PinholeLicenseService} from "../../services/pinhole.license.service";

@Component({
    selector: 'add-server-license',
    templateUrl: './add-server-license.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent
    ],
    providers: [AlertService]
})
export class AddServerLicenseComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable
    private duration = this.formBuilder.control("")

    readonly iid = input.required<string>();
    isLoading: boolean = false;

    form = new FormGroup({
        duration: this.duration
    });

    constructor(private service: PinholeLicenseService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    add() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.subscriptions.push(
            this.service.setLicense({
                iid: this.iid(),
                durationDays: parseInt(this.duration.value)
            }).subscribe({
                next: () => {
                    this.alertService.showAlert('success', "License added");
                    this.isLoading = false;
                },
                error: (_: HttpErrorResponse) => {
                    this.alertService.showAlert('danger', "An error accured");
                    this.isLoading = false;
                }
            }))
    }
}
